module.exports = __webpack_public_path__ + "static/picwords-settings-a3ac4caf2a5740c89a82522348006aaa.png";